import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { validateEmail } from '@Utils/Email';
import { TextInput } from '@els/els-react--text-input';
import { Button } from '@els/els-react--button';
import { Logo } from '@els/els-react--logo';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

import './BulkIdRegisterModal.scss';

function BulkIdRegisterModal({ isLoading, emailSubmit, onModalClosed, selfClose, closed }) {
  const [email, setEmail] = useState('');
  const [emailInvalid, setEmailInvalid] = useState(false);

  const onSubmit = () => {
    if (isLoading) {
      return;
    }

    if (validateEmail(email)) {
      setEmailInvalid(false);
      emailSubmit(email);
    } else {
      setEmailInvalid(true);
    }
  };

  const onInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };

  useEffect(
    () => () => {
      onModalClosed();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className="bulk-id-register-modal">
      <div className="bulk-id-register-modal__content">
        <div className="bulk-id-register-modal__header">
          <Logo className="bulk-id-register-modal__logo" />
          <h4 className="bulk-id-register-modal__title">Activating a registration ID</h4>
        </div>

        <p className="bulk-id-register-modal__description">
          You are activating a registration ID. Validate your email account to continue with the redemption process.
        </p>

        <TextInput
          id="bulk-id-email"
          label="Email account"
          placeholder="Enter your email"
          required
          value={email}
          onChange={(e) => setEmail(e?.target?.value)}
          onKeyDown={onInputKeyDown}
          data-e2e="bulk-id-email-input"
          className="e2e-bulk-id-email-input bulk-id-register-modal__input"
          isInvalid={emailInvalid}
          invalidMessage={emailInvalid ? 'Incorrect email address' : undefined}
          autoFocus
        />

        {isLoading && <SimpleSpinner />}

        <Button
          type="primary"
          expanded
          onClick={onSubmit}
          data-e2e="bulk-id-email-submit-button"
          className="e2e-bulk-id-email-continue bulk-id-register-modal__button">
          Continue
        </Button>
      </div>
    </div>
  );
}

BulkIdRegisterModal.propTypes = {
  isLoading: PropTypes.bool,
  emailSubmit: PropTypes.func.isRequired,
  onModalClosed: PropTypes.func.isRequired,
  selfClose: PropTypes.func.isRequired,
  closed: PropTypes.bool,
};

export default BulkIdRegisterModal;
